import { render, staticRenderFns } from "./addApproval.vue?vue&type=template&id=01bb21f7&scoped=true"
import script from "./addApproval.vue?vue&type=script&lang=js"
export * from "./addApproval.vue?vue&type=script&lang=js"
import style0 from "./addApproval.vue?vue&type=style&index=0&id=01bb21f7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bb21f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01bb21f7')) {
      api.createRecord('01bb21f7', component.options)
    } else {
      api.reload('01bb21f7', component.options)
    }
    module.hot.accept("./addApproval.vue?vue&type=template&id=01bb21f7&scoped=true", function () {
      api.rerender('01bb21f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/approvalManagement/addApproval.vue"
export default component.exports